import { render, staticRenderFns } from "./SurveyComments.vue?vue&type=template&id=27315817&"
import script from "./SurveyComments.vue?vue&type=script&lang=js&"
export * from "./SurveyComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports